import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import ContractorHero from './components/ContractorHero';
import ContractorPainPoints from './components/ContractorPainPoints';
import ContractorHowHelps from './components/ContractorHowHelps';
import ContractorExamples from './components/ContractorExamples';
import ContractorHowItWorks from './components/ContractorHowItWorks';
import ContractorBenefits from './components/ContractorBenefits';
import ContractorFAQ from './components/ContractorFAQ';
import ContractorCTA from './components/ContractorCTA';

export default function ContractorsPage() {
  return (
    <>
      <title>AI Ads for Contractors | Get More Leads with Contractor Advertising | AdForge</title>
      <meta
        name="description"
        content="AI ads for contractors that actually get leads. AdForge creates Facebook ads for contractors, Google ads, and Instagram ads in minutes. No marketing experience needed. Try free."
      />
      <meta
        name="keywords"
        content="AI ads for contractors, contractor advertising, facebook ads for contractors, google ads for contractors, home service advertising, local contractor marketing"
      />
      <link rel="canonical" href="https://adforge.ai/ai-ads-for-contractors" />
      <meta name="Last-modified" content={new Date().toISOString().split('T')[0]} />

      <meta property="og:type" content="website" />
      <meta property="og:title" content="AI Ads for Contractors | AdForge — Get More Leads" />
      <meta
        property="og:description"
        content="AI-powered contractor advertising that gets real leads. Build Facebook ads for contractors, Google ads, and more in minutes. No experience needed."
      />
      <meta property="og:url" content="https://adforge.ai/ai-ads-for-contractors" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="AI Ads for Contractors | AdForge" />
      <meta
        name="twitter:description"
        content="Stop wasting money on ads that don't work. AdForge builds AI ads for contractors in minutes. Free to start."
      />

      <script type="application/ld+json">{JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: 'AI Ads for Contractors — AdForge',
        description:
          'AdForge creates AI ads for contractors, roofers, landscapers, and home service businesses. Generate Facebook ads for contractors and Google ads in minutes.',
        url: 'https://adforge.ai/ai-ads-for-contractors',
        mainEntity: {
          '@type': 'SoftwareApplication',
          name: 'AdForge AI Ad Generator for Contractors',
          applicationCategory: 'BusinessApplication',
          operatingSystem: 'Web',
          offers: {
            '@type': 'Offer',
            price: '0',
            priceCurrency: 'USD',
            description: 'Free plan available — no credit card required',
          },
          aggregateRating: {
            '@type': 'AggregateRating',
            ratingValue: '4.9',
            reviewCount: '1240',
          },
        },
      })}</script>

      <script type="application/ld+json">{JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: 'Do I need marketing experience to use AI ads for contractors?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'No. AdForge is built for contractors with zero marketing experience. You answer a few simple questions about your business and the AI does the rest — writing the copy, generating images, and formatting ads for Facebook, Instagram, and Google.',
            },
          },
          {
            '@type': 'Question',
            name: 'How much do Facebook ads for contractors cost?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'AdForge is free to start. Paid plans start at $29/month. Your actual Facebook ad spend is separate and set by you directly in Facebook Ads Manager.',
            },
          },
          {
            '@type': 'Question',
            name: 'What types of contractors can use AdForge?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'AdForge works for all home service and contractor businesses including roofers, landscapers, general contractors, plumbers, electricians, HVAC companies, painters, and more.',
            },
          },
          {
            '@type': 'Question',
            name: 'How fast can I create contractor advertising with AdForge?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Most contractors generate their first complete ad package — including copy, headlines, hooks, and AI images — in under 3 minutes.',
            },
          },
          {
            '@type': 'Question',
            name: 'Does AdForge create Google ads for contractors too?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Yes. AdForge generates ad copy optimized for Facebook, Instagram, Google Ads, TikTok, and LinkedIn. You get platform-specific formatting for each.',
            },
          },
        ],
      })}</script>

      <div className="min-h-screen bg-white">
        <Navbar />
        <main>
          <ContractorHero />
          <ContractorPainPoints />
          <ContractorHowHelps />
          <ContractorExamples />
          <ContractorHowItWorks />
          <ContractorBenefits />
          <ContractorFAQ />
          <ContractorCTA />
        </main>
        <Footer />
      </div>
    </>
  );
}
